const getters = {
  listAll: state => {
    return state.network_list
  },
  listSelected: state => {
    if (state.client_selected) {
      let networks = []
      for (let index = 0; index < state.network_list.length; index++) {
        const element = state.network_list[index]
        if (element.Client.id === state.client_selected.id) networks.push(element)
      }
      return networks
    }
    return state.network_list
  }
}
export default getters



//////////////////
// WEBPACK FOOTER
// ./state/network/network.getters.js
// module id = null
// module chunks = 